// const ACTION_TYPE = {
//     READ: 1,
//     MODIFY: 2,
//     CREATE: 3,
//     DELETE: 4
// }

const DELEGATION_RIGHTS = {
    READ: 1,
    WRITE: 2 // comprend écriture, modification et suppression
}

const DB_COLLECTIONS = { 
    CLIPOD: 4,
    VARIABLE: 5,
    METERING: 6,
    TIMESERIES: 7,
    LOCATION: 8,
    METADATA: 11,
    ALERT: 12,
    EVENTS: 13,
    PRICINGPERIOD: 17,
    COSTESTIMATION: 18,
    POD: 19
}

// certaines limitations peuvent s'ajouter par dessus
// meme si elles ne sont pas citées dans cet objet.
// par exemple, un index ajouté par le GRD ne pourra jamais
// etre modifié ou supprimé par un utilisateur, peut importe son
// role sur le POD
const DELEGATION_PERMISSIONS = [
    {
        USER_RIGHTS: DELEGATION_RIGHTS.READ,
        RIGHTS_PER_COLLECTION: [
            {
                collection: DB_COLLECTIONS.VARIABLE,
                mustBeLinkedToUser: false,
                canRead: true,
                canCreateNew: false,
                canModify: false,
                canDelete: false
            },
            {
                collection: DB_COLLECTIONS.METERING,
                mustBeLinkedToUser: false,
                canRead: true,
                canCreateNew: false,
                canModify: false,
                canDelete: false
            },
            {
                collection: DB_COLLECTIONS.TIMESERIES,
                mustBeLinkedToUser: false,
                canRead: true,
                canCreateNew: false,
                canModify: false,
                canDelete: false
            },
            {
                collection: DB_COLLECTIONS.LOCATION,
                mustBeLinkedToUser: false,
                canRead: true,
                canCreateNew: false,
                canModify: false,
                canDelete: false
            },
            {
                collection: DB_COLLECTIONS.METADATA,
                mustBeLinkedToUser: false,
                canRead: true,
                canCreateNew: false,
                canModify: false,
                canDelete: false
            },
            {
                collection: DB_COLLECTIONS.ALERT,
                // true : signifie que l'alerte en question doit avoir une "clé étrangère" vers le user
                // qui veut faire l'opération (peut importe laquelle)
                // si ce n'est pas le cas, l'opération n'est pas exécutée
                mustBeLinkedToUser: true,
                canRead: true,
                canCreateNew: true,
                canModify: true,
                canDelete: true
            },
            {
                collection: DB_COLLECTIONS.EVENTS,
                mustBeLinkedToUser: false,
                canRead: true,
                canCreateNew: false,
                canModify: false,
                canDelete: false
            },
            {
                collection: DB_COLLECTIONS.PRICINGPERIOD,
                mustBeLinkedToUser: false,
                canRead: true,
                canCreateNew: false,
                canModify: false,
                canDelete: false
            },
            {
                collection: DB_COLLECTIONS.COSTESTIMATION,
                mustBeLinkedToUser: false,
                canRead: true,
                canCreateNew: false,
                canModify: false,
                canDelete: false
            },
            {
                collection: DB_COLLECTIONS.POD,
                mustBeLinkedToUser: false,
                canRead: true,
                canCreateNew: false,
                canModify: false,
                canDelete: false
            },
        ]
    },
    {
        USER_RIGHTS: DELEGATION_RIGHTS.WRITE,
        RIGHTS_PER_COLLECTION: [
            {
                collection: DB_COLLECTIONS.VARIABLE,
                mustBeLinkedToUser: false,
                canRead: true,
                canCreateNew: true,
                canModify: true,
                canDelete: true
            },
            {
                collection: DB_COLLECTIONS.METERING,
                mustBeLinkedToUser: false,
                canRead: true,
                canCreateNew: true,
                canModify: true,
                canDelete: true
            },
            {
                collection: DB_COLLECTIONS.TIMESERIES,
                mustBeLinkedToUser: false,
                canRead: true,
                canCreateNew: true,
                canModify: true,
                canDelete: true
            },
            {
                collection: DB_COLLECTIONS.LOCATION,
                mustBeLinkedToUser: false,
                canRead: true,
                canCreateNew: false,
                canModify: false,
                canDelete: false
            },
            {
                collection: DB_COLLECTIONS.METADATA,
                mustBeLinkedToUser: false,
                canRead: true,
                canCreateNew: false,
                canModify: false,
                canDelete: false
            },
            {
                collection: DB_COLLECTIONS.ALERT,
                // true : signifie que l'alerte en question doit avoir une "clé étrangère" vers le user
                // qui veut faire l'opération (peut importe laquelle)
                // si ce n'est pas le cas, l'opération n'est pas exécutée
                mustBeLinkedToUser: true,
                canRead: true,
                canCreateNew: true,
                canModify: true,
                canDelete: true
            },
            {
                collection: DB_COLLECTIONS.EVENTS,
                mustBeLinkedToUser: false,
                canRead: true,
                canCreateNew: false,
                canModify: false,
                canDelete: false
            },
            {
                collection: DB_COLLECTIONS.PRICINGPERIOD,
                mustBeLinkedToUser: false,
                canRead: true,
                canCreateNew: true,
                canModify: true,
                canDelete: true
            },
            {
                collection: DB_COLLECTIONS.COSTESTIMATION,
                mustBeLinkedToUser: false,
                canRead: true,
                canCreateNew: true,
                canModify: true,
                canDelete: true
            },
            {
                collection: DB_COLLECTIONS.POD,
                mustBeLinkedToUser: false,
                canRead: true,
                canCreateNew: false,
                canModify: true,
                canDelete: true
            },
        ]
    }
]

function getDelegationRight(clipod) {
    if(!clipod)
        return null
    if(clipod.hasWritePermission)
        return DELEGATION_RIGHTS.WRITE
    if(clipod.hasReadPermission)
        return DELEGATION_RIGHTS.READ
    return null
}

function whatCanDelegatedUserDo({ collection, delegationRight }) {
    return DELEGATION_PERMISSIONS.find(permission => permission.USER_RIGHTS == delegationRight)
        .RIGHTS_PER_COLLECTION
        .find(collectionInfo => collectionInfo.collection == collection)
}

exports.DELEGATION_RIGHTS = DELEGATION_RIGHTS
exports.DB_COLLECTIONS = DB_COLLECTIONS
// exports.DELEGATION_PERMISSIONS = DELEGATION_PERMISSIONS
exports.getDelegationRight = getDelegationRight
exports.whatCanDelegatedUserDo = whatCanDelegatedUserDo